'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { SectionTitle } from '@/widgets/landing/medicontents/ui/molecules';
import * as S from './styles';

const PainPointSection = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isLg = useIsDesktop();

  return (
    <section id="pain-point-section" className={S.section}>
      <SectionTitle title={{ text: `지금 병원 마케팅\n이런 고민 있으신가요?` }} subtitle={{ text: `실제 상담에서 가장 많이 듣는 고민만 모았습니다.`, gap: 'mt-2.5 md:mt-4' }} />
      <div className={S.cardsWrap}>
        {Array.from({ length: 3 }).map((_, index) => (
          <motion.div
            key={`pain-point-${index}`}
            className={S.card}
            style={{ top: `${isLg ? index * 97.92 : index * 10}rem` }}
            initial={{ y: 55, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.75 }}
            transition={{ duration: 0.7, ease: 'easeOut', delay: isLg ? 0 : index * 0.12 }}
          >
            <Image src={`${baseImageUrl}/medicontents/landing/pain0${index + 1}.png`} alt={`pain-point-${index + 1}`} fill sizes={'100%'} className={S.cardImage} />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default PainPointSection;
